import { ORG_OVERRIDE_STORAGE_KEY } from '#shared/organizations/orgOverride'
import { readPref, writePref } from '~/composables/usePersistedPref'

/**
 * The browser's half of the super-admin org override (MAR-427).
 *
 * The override used to be an HttpOnly cookie the server set, which meant the browser could neither
 * see it nor stop sending it — every request carried an impersonation whether or not it meant to.
 * It is client state now: stored here, attached to each `/api/**` request as
 * `x-marcus-org-override` by `app/plugins/api.ts`, and dropped the moment the server refuses it.
 *
 * Every access goes through `readPref`/`writePref`, which absorb a storage that throws (a browser
 * configured to block site data) — and this runs on the path that builds EVERY request. An override
 * that cannot be read is simply no override; one that cannot be written means the super-admin acts
 * as themselves, which is the safe direction for a failed impersonation.
 */

export function getStoredOrgOverride(): string | null {
  if (!import.meta.client) return null
  return readPref(ORG_OVERRIDE_STORAGE_KEY)
}

export function setStoredOrgOverride(organizationId: string): void {
  if (import.meta.client) writePref(ORG_OVERRIDE_STORAGE_KEY, organizationId)
}

export function clearStoredOrgOverride(): void {
  if (import.meta.client) writePref(ORG_OVERRIDE_STORAGE_KEY, null)
}
